import React from "react";
import GridContainer from "../../../@jumbo/components/GridContainer";
import PageContainer from "../../../@jumbo/components/PageComponents/layouts/PageContainer";
import IntlMessages from "../../../@jumbo/utils/IntlMessages";

import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import { Box, Button } from "@material-ui/core";

import AllPrizes from "@jumbo/Dashboards/PointShop";
import { Add } from "@material-ui/icons";
import { useHistory } from "react-router-dom";

const breadcrumbs = [
  { label: <IntlMessages id={"sidebar.main"} />, link: "/" },
  { label: <IntlMessages id={"pages.pointShop"} />, isActive: true },
];

const PointShop = () => {
  const history = useHistory();
  return (
    <PageContainer
      heading={<IntlMessages id="pages.pointShop" />}
      breadcrumbs={breadcrumbs}
    >
      <GridContainer>
        <Grid item xs={12}>
          <Box
            marginBottom={"10px"}
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <div>
              <IntlMessages id="pages.pointShop.description" />
            </div>
            <Button
              variant="contained"
              color="primary"
              startIcon={<Add />}
              onClick={() => history.push("/addPrize")}
              style={{ marginRight: 14 }}
            >
              ساخت جایزه
            </Button>
          </Box>
          <Divider />
          <div style={{ marginTop: 24 }}>
            <AllPrizes />
          </div>
        </Grid>
      </GridContainer>
    </PageContainer>
  );
};

export default PointShop;
